module.exports = __webpack_public_path__ + "img/FSP_logo.c0b96639.png";